import type { MenuDefinition } from '@1js/acui-menu/lib/components/MenuDefinition';
import type { RibbonFlyoutAnchorProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { constructKeytip, getKeytipString } from 'owa-command-ribbon';
import { getComposeRibbonId } from 'owa-editor/lib/utils/getComposeRibbonId';
import Attach from 'owa-fluent-icons-svg/lib/icons/AttachRegular';
import BookContacts from 'owa-fluent-icons-svg/lib/icons/BookContactsRegular';
import Flag from 'owa-fluent-icons-svg/lib/icons/FlagRegular';
import loc from 'owa-localize';
import GroupStrings from 'owa-locstrings/lib/strings/ribbon_mail_groups.locstring.json';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import { MailRibbonGroupId, MailRibbonTabId } from 'owa-ribbon-ids';
import { createMailAppFlyoutAnchor } from '../../../util/createMailRibbonButton';

const emptyMenuDefinition: MenuDefinition = {
    sections: [],
};

export const getMLRMessageTabCommonGroupFlyout = computedFn(
    (
        group: RibbonGroupId,
        popoutComposeViewState?: ComposeViewState
    ): RibbonFlyoutAnchorProps | undefined => {
        const isPopout: boolean = popoutComposeViewState != undefined;

        switch (group) {
            case MailRibbonGroupId.Group_Include:
                const includeGroupId: string = getComposeRibbonId(
                    group,
                    popoutComposeViewState
                ).toString();
                return createMailAppFlyoutAnchor(
                    includeGroupId,
                    loc(GroupStrings.include_Group),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    constructKeytip(
                        [getKeytipString(MailRibbonTabId.Tab_Message)],
                        getKeytipString(MailRibbonGroupId.Group_Include)
                    ),
                    Attach
                );

            case MailRibbonGroupId.Group_Names:
                const namesGroupId: string = getComposeRibbonId(
                    group,
                    popoutComposeViewState
                ).toString();
                return createMailAppFlyoutAnchor(
                    namesGroupId,
                    loc(GroupStrings.names_Group),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    constructKeytip(
                        [getKeytipString(MailRibbonTabId.Tab_Message)],
                        getKeytipString(MailRibbonGroupId.Group_Names)
                    ),
                    BookContacts
                );

            case MailRibbonGroupId.Group_Tags:
                const tagsGroupId: string = getComposeRibbonId(
                    group,
                    popoutComposeViewState
                ).toString();
                return createMailAppFlyoutAnchor(
                    tagsGroupId,
                    loc(GroupStrings.tags_GroupButton),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    constructKeytip(
                        [getKeytipString(MailRibbonTabId.Tab_Message)],
                        getKeytipString(MailRibbonGroupId.Group_Tags)
                    ),
                    Flag
                );

            default:
                return undefined;
        }
    }
);
